import { Labels } from "../model/Labels.js";
import { DiamondButton } from "./DiamondButton.js";

export interface MelodyInstrumentHeaderOptions {
    container: HTMLElement;
    labels: Labels;
}

export class MelodyInstrumentHeader {

    public readonly onRequestMelody = e5.Signal.create();

    private _options: MelodyInstrumentHeaderOptions;
    private _element: HTMLDivElement;
    private _level: number = 0;

    constructor(options: MelodyInstrumentHeaderOptions) {
        options = e5.object.merge({
        }, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "melody-instrument-header";
        this._element.innerHTML = `
            <div class="melody-instrument-header__left">
                <div class="melody-instrument-header__level"></div>
            </div>
            <div class="melody-instrument-header__middle">
                <div class="melody-instrument-header__title"></div>
                <div class="melody-instrument-header__subtitle"></div>
            </div>
            <div class="melody-instrument-header__right"></div>
            `;

        new DiamondButton({
            container: this._element.querySelector(".melody-instrument-header__right"),
            label: options.labels.text("melody.melody_instrument_header.button.label"),
            shape: "dia-small",
            filled: false,
            onClick: () => this.onRequestMelody.dispatch()
        });

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get level(): number {
        return this._level;
    }

    public set level(value: number) {
        if (this._level == value) {
            return;
        }
        this._level = value;
        this._element.querySelector(".melody-instrument-header__level").innerHTML
            = this._options.labels.text("melody.melody_instrument_header.title.prefix") + ` <span>${"\\".repeat(value)}</span>`
    }

    public get title(): string {
        return this._element.querySelector(".melody-instrument-header__title").textContent;
    }

    public set title(value: string) {
        this._element.querySelector(".melody-instrument-header__title").textContent = value;
    }

    public get subtitle(): string {
        return this._element.querySelector(".melody-instrument-header__subtitle").textContent;
    }

    public set subtitle(value: string) {
        this._element.querySelector(".melody-instrument-header__subtitle").textContent = value;
    }

    public get visible(): boolean {
        return !this._element.classList.contains("melody-instrument-header--hidden");
    }

    public set visible(value: boolean) {
        if (this.visible === value) {
            return;
        }
        this._element.classList.toggle("melody-instrument-header--hidden", !value);
    }
}